import React from 'react';
import './Button.css';

/**
 * PrimaryButton Component
 * Standardized primary button with outline styling
 * 
 * @param {function} onClick - Click handler
 * @param {ReactNode} children - Button content
 * @param {string} size - Button size: 'small'|'medium'|'large' (default: 'medium')
 * @param {boolean} disabled - Disabled state
 * @param {string} className - Additional CSS classes
 */
const PrimaryButton = ({ 
  onClick, 
  children, 
  size = 'medium', 
  disabled = false, 
  className = '' 
}) => {
  const sizeClass = size === 'large' ? 'btn-large' : size === 'small' ? 'btn-small' : '';
  
  return (
    <button
      className={`btn btn-primary ${sizeClass} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;














